import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Register from "./pages/Register";
import Manage from "./pages/Manage";
import Sessions from "./pages/Sessions";
import SessionDetail from "./pages/SessionDetail";
import JudgeScoring from "./pages/JudgeScoring";
import PuraskaraluAdmin from "./pages/PuraskaraluAdmin";
import EpisodeCreator from "./pages/EpisodeCreator";
import EpisodeTimestamps from "./pages/EpisodeTimestamps";
import EpisodeDetail from "./pages/EpisodeDetail";
import Jeedigunta from "./pages/Jeedigunta";
import JeedigntaSeason from "./pages/JeedigntaSeason";
import JeedigntaCategory from "./pages/JeedigntaCategory";
import JeedigntaWinnerForm from "./pages/JeedigntaWinnerForm";
import JeedigntaTrophyReport from "./pages/JeedigntaTrophyReport";
import JeedigntaResultsAdmin from "./pages/JeedigntaResultsAdmin";
import SiteHeader from "./components/SiteHeader";
import PageCornerBadges from "./components/PageCornerBadges";

// utsavam.kathakala.us shows Sessions as landing page
const hostname = window.location.hostname;
const isUtsavam = hostname === "utsavam.kathakala.us";

function App() {
  return (
    <Router>
      <SiteHeader />
      <PageCornerBadges />
      <Routes>
        <Route path="/" element={isUtsavam ? <Sessions /> : <Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/manage" element={<Manage />} />
        <Route path="/sessions" element={<Sessions />} />
        <Route path="/sessions/:sessionTitle" element={<SessionDetail />} />
        <Route path="/judge" element={<JudgeScoring />} />
        <Route path="/puraskaralu-admin" element={<PuraskaraluAdmin />} />
        <Route path="/episodes/:episodeId" element={<EpisodeDetail />} />
        <Route path="/episode-creator" element={<EpisodeCreator />} />
        <Route path="/episode-timestamps/:episodeId" element={<EpisodeTimestamps />} />

        {/* Public Jeedigunta Kathakala Puraskaralu pages */}
        <Route path="/jeedigunta/winner-form/:token" element={<JeedigntaWinnerForm />} />
        <Route path="/jeedigunta-trophy-report" element={<JeedigntaTrophyReport />} />
        <Route path="/jeedigunta-results-admin" element={<JeedigntaResultsAdmin />} />
        <Route path="/jeedigunta" element={<Jeedigunta />} />
        <Route path="/jeedigunta/:seasonSlug" element={<JeedigntaSeason />} />
        <Route path="/jeedigunta/:seasonSlug/:categorySlug" element={<JeedigntaCategory />} />

        {/* Redirect any unknown routes back to Home */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
